/**
 * Konfiguracja Sentry Toolbar
 *
 * Sentry Toolbar to narzędzie, które wyświetla krytyczne informacje z Sentry
 * bezpośrednio w aplikacji webowej, umośliwiając łatwiejsze debugowanie.
 */

import getPublicEnv from '../utils/getPublicEnv';

// Konfiguracja organizacji i projektu
export const SENTRY_TOOLBAR_CONFIG = {
  // Organizacja Sentry (pobierz z zmiennych środowiskowych)
  organizationSlug: process.env.NEXT_PUBLIC_SENTRY_ORG || getPublicEnv('NEXT_PUBLIC_SENTRY_ORG') || 'vox-org',
  // ID lub slug projektu (pobierz z zmiennych środowiskowych)
  projectIdOrSlug: process.env.NEXT_PUBLIC_SENTRY_PROJECT || getPublicEnv('NEXT_PUBLIC_SENTRY_PROJECT') || 'vox-frontend',
  // Środowisko (pobierz z zmiennych środowiskowych)
  environment: process.env.NEXT_PUBLIC_SENTRY_ENVIRONMENT || getPublicEnv('NEXT_PUBLIC_SENTRY_ENVIRONMENT') || 'development',
  // Pozycja toolbar na ekranie
  placement: 'right-edge' as const,
  // Motyw (system, dark, light)
  theme: 'system' as const,
  // Origin Sentry (dla self-hosted)
  sentryOrigin: process.env.NEXT_PUBLIC_SENTRY_URL || getPublicEnv('NEXT_PUBLIC_SENTRY_URL') || 'https://sentry.io',
  // ID elementu DOM
  domId: 'sentry-toolbar',
  // Debug mode (tylko w development)
  debug: 'logging'
};

// Funkcja do sprawdzania czy toolbar powinien być włączony
export const isSentryToolbarEnabled = (): boolean => {
  // Sprawdź czy jesteśmy w przeglądarce
  if (typeof window === 'undefined') {
    return false;
  }

  // Sprawdź czy użytkownik ma uprawnienia (opcjonalnie)
  // Możesz dodać dodatkową logikę tutaj

  return true;
};

// Funkcja do pobierania konfiguracji dla danego środowiska
export const getSentryToolbarConfig = () => {
  const isEnabled = isSentryToolbarEnabled();
  return {
    enabled: isEnabled,
    ...SENTRY_TOOLBAR_CONFIG
  };
};